<bit-dialog dialogSize="default" background="default" class="bv-send-success-dialog">
  <ng-container bitDialogTitle>
    <span>{{ "sendCreated" | i18n }}</span>
  </ng-container>
  <ng-container bitDialogContent>
    <div class="bv-send-success-dialog__content">
      <div class="bv-send-success-dialog__icon">
        <bit-svg [content]="activeSendIcon"></bit-svg>
      </div>

      <h3 bitTypography="h3" class="bv-send-success-dialog__title">
        {{ "sendCreatedSuccessfully" | i18n }}
      </h3>

      <p bitTypography="body1" class="bv-send-success-dialog__message">
        @let translationKey =
          send.authType === AuthType.Email
            ? "sendCreatedDescriptionEmail"
            : send.authType === AuthType.Password
              ? "sendCreatedDescriptionPassword"
              : "sendCreatedDescriptionV2";
        {{ translationKey | i18n: formattedExpirationTime }}
      </p>

      <bit-form-field class="bv-send-success-dialog__link-field">
        <bit-label>{{ "sendLink" | i18n }}</bit-label>
        <input bitInput readonly type="text" [value]="sendLink()" />
        <button
          type="button"
          bitIconButton="bwi-clone"
          bitSuffix
          [label]="'copyLink' | i18n"
          (click)="copyLink()"
        ></button>
      </bit-form-field>
    </div>
  </ng-container>

  <ng-container bitDialogFooter>
    <div class="bv-send-success-dialog__footer">
      <button type="button" bitButton buttonType="primary" (click)="copyLink()">
        {{ "copyLink" | i18n }}
      </button>
      <button type="button" bitButton buttonType="secondary" bitDialogClose>
        {{ "close" | i18n }}
      </button>
    </div>
  </ng-container>
</bit-dialog>
